angular.module('countryState', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('countryState').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider
    .state('state', {
        url         : "/state",
        templateUrl : server+"/views/m/state",
        controller  : 'countryState.list',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'Estados'
        }
    })

    .state('state_create', {
        url         : "/state/create",
        templateUrl : server+"/views/m/state/create",
        controller  : 'countryState.create',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'countryState',
            label: 'Adicionar'
        }
    })

    .state('state_show', {
        url         : "/state/:id",
        templateUrl : server+"/views/m/state/show",
        controller  : 'countryState.show',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'countryState',
            label: '{{countryState.id}}'
        }
    })

}]);

/**
 * List Controller
 */
angular.module('countryState').
controller('countryState.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$countryState', function($scope, $http, $auth, $q, NgTableParams, $countryState) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $countryState.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('countryState').
controller('countryState.create', ['$scope', '$countryState', '$countryState', function($scope, $countryState, $countryState) {
    $scope.save = function() {
        $countryState.save($scope.state).$promise.then(function(data) {
            $state.go('state_show', {
                id: data.id
            });
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('countryState').
controller('countryState.show', ['$countryState', '$scope', '$stateParams', '$uibModal', '$countryState',
function($countryState, $scope, $countryStateParams, $uibModal, $countryState) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $countryState.get({
        id: $countryStateParams.id
    }).$promise.then(function(data) {
        $scope.state = data;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$countryState', function($scope, $uibModalInstance, $countryState) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var state = $scope.$parent.state;

                $scope.confirm = function() {
                    $countryState.update({
                        id: countryState.id
                    }, state).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$countryState', '$scope', '$uibModalInstance', '$countryState', function($countryState, $scope, $uibModalInstance, $countryState) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var state = $scope.$parent.state;

                $scope.confirm = function() {
                    $countryState.delete({id:countryState.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('countryState');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);

/**
 * Factory
 */
angular.module('countryState').
factory("$countryState", function($resource) {
    var resource = $resource(api + 'state/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });
    return resource;
});
